module.exports = __webpack_public_path__ + "static/turtle-creek-house34-8914b94e6f7c99324133914be6dab5e8.jpg";